import TabsRoot from './TabsRoot'

export default TabsRoot
